'use strict';
$('.simple-video-banner').on("click", function() {
    var $videoHeroVideo = $(this).closest('.simple-video-banner').find('.simple-video-banner-video-wrapper');

    var $iframe = $(this).closest('.simple-video-banner').find('.simple-video-banner-video-wrapper iframe');
    if ($iframe.length > 0) {
        var $player = new Vimeo.Player($iframe);
        $player.on('ended',function(){
            videoEnded($videoHeroVideo);
          });
    }

    var $directVideo = $(this).closest('.simple-video-banner').find('.simple-video-banner-video-wrapper video');
    if ($directVideo.length > 0) {
        var $player = $directVideo.get(0);
        //this does not like working with the player var here for some reason, not enough caffeine to figure it out
        $($directVideo).on('ended',function(){
            videoEnded($videoHeroVideo);
          });
    }

    $videoHeroVideo.addClass("video-show");
    $player.play();
});

function videoEnded(videoHeroVideo) {
    setTimeout(function() {
        videoHeroVideo.removeClass("video-show");
    }, 500);
};

